import { useState } from "react";
import { Fab } from "@mui/material";
import { Layers as LayersIcon } from "@mui/icons-material";
import { useMap } from "react-leaflet";
import { styled } from "@mui/material/styles";

import { LayerManagerContext } from "src/types";
import { MapControlBase } from "../map/MapControlBase";
import { LayerManager } from "./LayerManager";

interface Props {
  defaultOpen?: boolean;
  context: LayerManagerContext;
}

export function LayerManagerOnMap(props: Props) {
  const [isOpen, setIsOpen] = useState(!!props.defaultOpen);
  const map = useMap();
  return render();

  function render() {
    if (!map) return null;

    return (
      <MapControlBase position="topright">
        <Styles>
          <LayerManager open={isOpen} context={props.context} map={map} />

          <Fab size="medium" onClick={() => setIsOpen(!isOpen)} color={isOpen ? "primary" : "default"}>
            <LayersIcon />
          </Fab>
        </Styles>
      </MapControlBase>
    );
  }
}

const Styles = styled("div")`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(1)};
`;
